// extracted by mini-css-extract-plugin
export var dropdownButton = "_1l-0";
export var fullWidthDropdownButton = "_1l-1";
export var icon = "_1l-3";
export var iconPlaceholder = "_1l-2";
export var shortcutContainer = "_1l-4";